import { render, staticRenderFns } from "./imgList.vue?vue&type=template&id=52c18e3d&"
import script from "./imgList.vue?vue&type=script&lang=js&"
export * from "./imgList.vue?vue&type=script&lang=js&"
import style0 from "./imgList.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports